<div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.seller && elementIds">
    <div class="banner center" style="max-width: 400px;">
        <div class="row">
            <div class="col-12">
                <label>{{localService.languageContent.seller.pick_business}}</label>
            </div>
        </div>
        <div class=" row">
            <div class="col-8">
                <input autocomplete="off" type="number" class="number"
                    (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.contact_nbr}}"
                    [(ngModel)]="contactNumber" style="width:100%;text-align: left;"
                    placeholder="*{{localService.languageContent.seller.map_contact_num}}"
                    title="{{localService.languageContent.seller.map_contact_num}}"
                    [ngClass]="contactNumber ? 'en' : ''" (keydown.enter)="onAction(1)" />
            </div>
            <div class="col-4" style="text-align: right;">
                <button id="{{elementIds.pick}}" type="button" [disabled]="!contactNumber" class="btn btn-primary"
                    (click)="onAction(1)">
                    {{localService.languageContent.common.pick}}
                </button>
            </div>
        </div>
    </div>
</div>
<div>
    <app-otp-container *ngIf="isShowOtpPopup" [IsOtpPopup]="true" (onVerified)="onVerifiedOtp($event)"
        [PhNumOrEmail]="contactNumber.toString()" [otpType]="OtpType.MobileVerification" [interactionType]="1"
        (onCancelled)="isShowOtpPopup = false" />
</div>